// extracted by mini-css-extract-plugin
export var bacgroundImage = "shared-module--bacgroundImage--ea3c0";
export var bgVideo = "shared-module--bgVideo--480e5";
export var desktopVideo = "shared-module--desktopVideo--a31e4";
export var languageLabel = "shared-module--languageLabel--07432";
export var languageOption = "shared-module--languageOption--ba286";
export var languageSwitcher = "shared-module--languageSwitcher--3946d";
export var mobileVideo = "shared-module--mobileVideo--71279";
export var overlay = "shared-module--overlay--21a56";
export var sectionContainer = "shared-module--sectionContainer--2b7b7";
export var videoContainer = "shared-module--videoContainer--68fac";